import { useState, useEffect } from "react";
import get from "lodash.get";
import set from "lodash.set";
import { useLMSGlobalReducer } from "../components/lms/LmsGlobalStore";

export const useLmsStoreSelector = (stateSelector = "" as string | string[], defaultValue = undefined as any) => {
  const [state, dispatch] = useLMSGlobalReducer();
  const [selectedStoreState, setSelectedStoreState] = useState(get(state, stateSelector, defaultValue) as any);
  const selectedState = stateSelector ? get(state, stateSelector) : state;

  const updateSelectedStoreState = (data, subSelector) => {
    const updatedData = subSelector ? set(selectedStoreState || {}, subSelector, data) : data;
    if (stateSelector) {
      dispatch({
        type: "SET_SELECTED_DATA",
        payload: {
          selectorString: stateSelector,
          data: updatedData,
        }
      });

      setSelectedStoreState(updatedData);
    }
  };

  useEffect(() => {
    if (stateSelector) {
      setSelectedStoreState(get(state, stateSelector, defaultValue));
    }
  }, [selectedState, stateSelector]);

  return [selectedStoreState, updateSelectedStoreState, dispatch] as any[];
};